"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Brand = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _Icons = require("./Icons");

var _core = require("@emotion/core");

var Brand = function Brand() {
  var _ref = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      domain = _ref2$.domain,
      isOpen = _ref2$.isOpen,
      isCustomType = _ref2$.isCustomType,
      currentConfig = _ref2$.currentConfig,
      ProductLogo = _ref2$.ProductLogo,
      _ref2$2 = _ref2[1],
      toggleOpen = _ref2$2.toggleOpen,
      handleDispatchMenuEvents = _ref2$2.handleDispatchMenuEvents;

  var name = currentConfig.name,
      link = currentConfig.link,
      colors = currentConfig.colors;

  var brandProductLogoProps = function brandProductLogoProps(productLink) {
    var propsWithLink = {
      as: 'a',
      href: "".concat(domain).concat(productLink)
    };
    var propsWithoutLink = {
      as: 'span'
    };
    return link ? propsWithLink : propsWithoutLink;
  };

  return (0, _core.jsx)(_UiComponents.Container.Brand, {
    bgColor: colors.background
  }, (0, _core.jsx)(_UiComponents.Container.BrandWrapper, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0,
    as: "a",
    href: "".concat(domain, "/"),
    onClick: function onClick() {
      handleDispatchMenuEvents({
        action: 'inbound links | logo creditas',
        label: "".concat(domain, "/")
      });
    }
  }, isCustomType ? (0, _core.jsx)(_Icons.CreditasIcon, null) : (0, _core.jsx)(_UiComponents.CreditasLogo, null)), isCustomType && (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center",
    padding: 0
  }, (0, _core.jsx)(_UiComponents.Container.BrandProductLogo, (0, _extends2.default)({
    color: colors.active
  }, brandProductLogoProps(link), {
    onClick: function onClick() {
      handleDispatchMenuEvents({
        action: "inbound links | logo ".concat(name.toLowerCase()),
        label: link ? "".concat(domain).concat(link) : ''
      });
    }
  }), (0, _core.jsx)(ProductLogo, null))), (0, _core.jsx)(_UiComponents.Container.MenuToggle, {
    as: "button",
    "aria-label": "Toggle Menu",
    onClick: toggleOpen
  }, (0, _core.jsx)(_UiComponents.Toggle, {
    fontColor: colors.font,
    "aria-hidden": true
  }, isOpen ? (0, _core.jsx)(_Icons.Close, null) : (0, _core.jsx)(_Icons.Menu, null)))));
};

exports.Brand = Brand;
Brand.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Brand"
};